module.exports = __webpack_public_path__ + "img/M55CNCshow-3.6bd29305.jpg";